import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, tap } from 'rxjs';
import { ConfigService } from './config.service';
import {
  ApiPayRequest,
  ApiPaymentProvider,
  ApiUniversalPayResponse,
  PayStatus,
} from '../models/payment-api.models';
import { ApiConfigService } from './api-config.service';

@Injectable({ providedIn: 'root' })
export class PaymentApiService {
  constructor(
    private readonly http: HttpClient,
    private readonly apiConfig: ApiConfigService,
    private readonly configService: ConfigService,
  ) {}

  fetchProviders(): Observable<ApiPaymentProvider[]> {
    const url = this.apiConfig.paymentProvidersUrl;
    return this.http.get<ApiPaymentProvider[]>(url).pipe(
      tap((response) => {
        if (this.configService.enableApiLogs) {
          console.log('[PaymentApi] providers', url, response);
        }
      }),
    );
  }

  pay(dto: ApiPayRequest): Observable<ApiUniversalPayResponse> {
    const url = this.apiConfig.paymentPayUrl;
    return this.http.post<Record<string, unknown>>(url, dto).pipe(
      map((response) => this.parsePayResponse(response)),
      tap((response) => {
        if (this.configService.enableApiLogs) {
          console.log('[PaymentApi] pay result', response);
        }
      }),
    );
  }

  private parsePayResponse(raw: Record<string, unknown>): ApiUniversalPayResponse {
    const nested = raw['data'];
    const source =
      nested && typeof nested === 'object' ? (nested as Record<string, unknown>) : raw;

    const statusRaw = String(source['status'] ?? raw['status'] ?? '').toUpperCase();
    const allowed: PayStatus[] = [
      'PENDING',
      'SUCCESSFULL',
      'FAILED',
      'ABORTED',
      'CANCELLED',
      'UNKNOWN',
    ];
    const status = allowed.includes(statusRaw as PayStatus)
      ? (statusRaw as PayStatus)
      : 'UNKNOWN';

    return {
      status,
      message: String(source['message'] ?? raw['message'] ?? ''),
      reference: String(source['reference'] ?? raw['reference'] ?? ''),
    };
  }
}
